module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("efrZJ"))).then(() => parcelRequire('hEqeo'));